import pluralize from 'pluralize'

export default async ({ app, router, Vue }) => {
  Vue.prototype.$pluralize = pluralize
}
